import { render, staticRenderFns } from "./InvoiceDeliverySection.vue?vue&type=template&id=6efd8f10"
import script from "./InvoiceDeliverySection.vue?vue&type=script&lang=js"
export * from "./InvoiceDeliverySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports